import { IChungChiChungNhan } from "../../model/response/chung-chi-chung-nhan/IChungChiChungNhan";
import { apiClient } from "../apiClient";

export const CHUNG_CHI_CHUNG_NHAN_ENDPOINT = 'chung-chi-chung-nhan';
export const chungChiChungNhanApi = {
    SelectAll: () => apiClient.get(`${CHUNG_CHI_CHUNG_NHAN_ENDPOINT}`),
    Insert: (data: IChungChiChungNhan) => apiClient.post(`${CHUNG_CHI_CHUNG_NHAN_ENDPOINT}`, data),
    Update: (id: number, data: IChungChiChungNhan) => apiClient.put(`${CHUNG_CHI_CHUNG_NHAN_ENDPOINT}/${id}`, data),
    Delete: (id: number) => apiClient.delete(`${CHUNG_CHI_CHUNG_NHAN_ENDPOINT}/${id}`),
}